// extracted by mini-css-extract-plugin
export var header = "_wp-1";
export var maskBottom = "_wp-6";
export var maskMiddle = "_wp-7";
export var maskTop = "_wp-5";
export var root = "_wp-0";
export var scrollDownButton = "_wp-3";
export var scrollDownButtonHidden = "_wp-4";
export var viewport = "_wp-2";